import { SxProps } from '@mui/system'

type DocumentoTableElements = {
  documentIcon: SxProps
  container: SxProps
  autocomplete: SxProps
  textarea: SxProps
  boxFile: SxProps
  boxFileName: SxProps
  boxSign: SxProps
}

export const documentTableStyles: DocumentoTableElements = {
  documentIcon: { marginRight: '6px', position: 'relative', top: '1px' },
  container: { display: 'flex', width: '100%', marginTop: '16px', marginBottom: '16px' },
  autocomplete: { flex: '1 1 auto' },
  textarea: { flex: '1 1 auto' },
  boxFile: { display: 'flex', flexDirection: 'column' },
  boxFileName: { display: 'flex', alignItems: 'center' },
  boxSign: {
    marginTop: '10px',
    color: '#001978',
    fontSize: '12px',

    '& .MuiFormControlLabel-root': {
      display: 'block'
    },

    '& .MuiFormControlLabel-label': {
      display: 'block',
      margin: '8px 0'
    }
  }
}
